<template>
  <div class="galileo-login-logo">
    <img src="@/assets/img/galileo-logo.svg" />
  </div>
</template>

<script setup lang="ts">
</script>

<style></style>
